<template>
<footer class="footer is-paddingless">
  <div class="content has-text-centered">
    <p class="is-size-7-mobile text-shadow-s2">
      <b>MUCRISIS V1.0 2020 <fa icon="copyright" /></b> <a href="/" class="has-text-dark">{{vip}}</a> 
      <br>  Todos los derechos farmeados. <router-link to="/politica-de-privacidad" class="has-text-info">Política de privacidad</router-link>
    </p>
  </div>
</footer>  
</template>

<script>
export default {
    name:'Footer',
    data:()=>({
      vip: "<Programador Vip />"
    })
}
</script>

<style scoped>
  .footer {
    background-color:inherit !important;
  }
</style>